import './Reset.css'
import Router from "./routes/Router";

import { ThemeProvider } from "@mui/material/styles";
import muiTheme from "./theme/muiTheme";
import ThemeVars from "./theme/ThemeVars";


function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <ThemeVars />
      <Router/>
    </ThemeProvider>

  );
}

export default App;
